module.exports = __webpack_public_path__ + "static/media/footerimg.cc9ee944.webp";